import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { LoaderGIF } from 'Images';

export const Loading = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .loading;

  return (
    <Stack
      justifyContent='center'
      alignItems='center'
      gap={isDesktop ? '64px' : undefined}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        bgcolor: '#FFF',
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        gap='12px'
        alignItems='center'
        sx={{
          width: 'fit-content',
        }}
      >
        <Typography variant='h3'>{dictionary.fewMoments}</Typography>
        {isDesktop && (
          <Typography
            variant='h4'
            sx={{
              fontWeight: 'bold !important',
            }}
          >
            {dictionary.pageLoading}
          </Typography>
        )}
      </Stack>
      <Avatar alt='' src={LoaderGIF} sx={{ width: '200px', height: '200px' }} />
    </Stack>
  );
};
